import CoreLocationsListingGroups from './CoreLocationsListingGroups';

export { type CoreLocationsListingGroupsProps } from './CoreLocationsListingGroups';
export default CoreLocationsListingGroups;
